import styled, { css } from 'styled-components';

// export default styled.div`
//   position: relative;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-image: url(${props => props.src});
//   background-size: ${props => props.scaleMode};
//   background-position: ${props => props.position};
//   background-repeat: no-repeat;
//   transition-property: opacity, visibility;
//   transition-duration: 0.3s;
//   transition-timing-function: ease;

//   ${props => props.hidden && css`
//     display: block;
//     opacity: 0;
//     visibility: hidden;
//   `};
// `;

export default styled.img`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-size: ${props => props.scaleMode};
  background-position: ${props => props.position};
  background-repeat: no-repeat;
  transition-property: opacity, visibility;
  transition-duration: 0.3s;
  transition-timing-function: ease;

  ${props =>
    props.hidden &&
    css`
      display: block;
      opacity: 0;
      visibility: hidden;
    `};
`;
